/**
 * Every fixed segment of an API path. Anything else (business ids, appointment
 * ids, public booking slugs, share tokens) is collapsed to `:id`, so an unknown
 * or user-chosen value can never reach a report. It fails closed: a new route
 * segment simply groups under `:id` until it is added here.
 */
const STATIC_SEGMENTS = new Set([
    'accept',
    'addons',
    'adjustments',
    'admin',
    'alerts',
    'analytics',
    'apply-template',
    'appointments',
    'audiences',
    'auth',
    'authorize',
    'availability',
    'billing',
    'booking-intent',
    'bridge',
    'bulk-review',
    'bundles',
    'business',
    'business-hours',
    'business-templates',
    'businesses',
    'campaigns',
    'cancel',
    'cancellation-policy',
    'capacity',
    'chat',
    'checkout',
    'cleanup-orphan-memberships',
    'clients',
    'concierge',
    'confirm',
    'connect',
    'conversations',
    'delivery',
    'devices',
    'disconnect',
    'dismiss',
    'email-preview',
    'events',
    'exceptions',
    'experiments',
    'extract-from-photo',
    'follow-up-policy',
    'follow-ups',
    'history',
    'import',
    'internal',
    'invites',
    'links',
    'lookup',
    'loyalty',
    'loyalty-program',
    'maintenance',
    'manage',
    'me',
    'members',
    'messages',
    'no-show',
    'notes',
    'nudges',
    'onboard',
    'onboarding',
    'onboarding-draft',
    'organic-funnel',
    'payments',
    'performance',
    'portal',
    'preferences',
    'preview',
    'profile',
    'provider',
    'providers',
    'public',
    'push',
    'rate',
    'read',
    'record',
    'refresh',
    'refund',
    'reminder-policy',
    'reorder',
    'reports',
    'request-confirmation',
    'reschedule',
    'retention',
    'risk-policy',
    'route',
    'salon-price-list',
    'scan',
    'schedule',
    'scheduler',
    'search',
    'self',
    'service-assignments',
    'services',
    'session',
    'settings',
    'shares',
    'skills',
    'square',
    'stats',
    'status',
    'stream',
    'subscription',
    'suggestions',
    'summary',
    'sync',
    'tags',
    'test',
    'test-email',
    'timeline',
    'today',
    'tools',
    'transactions',
    'unmatched',
    'unread-count',
    'user',
    'user-outreach',
    'users',
    'v1',
    'verify-email',
    'verify-token',
]);
/** Collapses ids and opaque tokens so reports group by route (`/admin/appointments/:id/cancel`). */
export function normalizeApiRoute(path) {
    const pathname = path.split(/[?#]/)[0] ?? '';
    return (pathname
        .split('/')
        .map((segment) => (!segment || STATIC_SEGMENTS.has(segment) ? segment : ':id'))
        .join('/') || '/');
}
//# sourceMappingURL=telemetry-routes.js.map